import React from 'react'
import ReactDOM from 'react-dom/client'
import 'regenerator-runtime/runtime'
import { ResourceCenter } from './ResourceCenter'

const app = document.getElementById('ResourceCenterResults')
if (app) {
  const root = ReactDOM.createRoot(
    document.getElementById('ResourceCenterResults')
  )
  root.render(<ResourceCenter />)
}
